<template>
<div class="chapter">
<div class="inner_page">
<p class="author"><a id="page_iii"></a><span class="small">JOHN GUARE</span></p>
<h1 class="h1">Landscape of the Body</h1>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?98ae02be